import * as XLSX from "xlsx-js-style";

const exportParticipantsToExcel = (participants, tripName, variantName) => {
  if (!participants || participants.length === 0) return;

  const now = new Date();
  const formattedDateTime = now.toLocaleString("pl-PL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  const safeTripName = tripName?.replace(/[\\/:*?"<>|]/g, "") || "Wycieczka";
  const safeVariantName = variantName?.replace(/[\\/:*?"<>|]/g, "") || "";
  const fileName = `${safeTripName}${safeVariantName ? "_" + safeVariantName : ""}_os_uczestniczące_${now.toISOString().split("T")[0]}.xlsx`;

  const headerTrip = [`${tripName || "Wycieczka"}`];
  const headerVariant = variantName ? [`${variantName}`] : [""];
  const headerDate = [`Wygenerowano: ${formattedDateTime}`];

  const headers = ["Imię i nazwisko", "Zaimki", "Telefon", "Email"];

  const sortedParticipants = [...participants].sort((a, b) =>
    (a.preferredName || `${a.firstName ?? ""} ${a.lastName ?? ""}`)
      .localeCompare(b.preferredName || `${b.firstName ?? ""} ${b.lastName ?? ""}`, "pl")
  );

const rows = sortedParticipants.map((p) => [
  p.preferredName ?? `${p.firstName ?? ""} ${p.lastName ?? ""}`,
  p.pronouns?.trim() || "",
  p.phone ?? "",
  p.email ?? "",
]);

  const fullSheetData = [
    headerTrip,
    headerVariant,
    headerDate,
    [],
    headers,
    ...rows,
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(fullSheetData);

  const tripStyle = {
    font: { bold: true, sz: 16, color: { rgb: "1F4E79" } },
    alignment: { horizontal: "left" },
  };

  const variantStyle = {
    font: { bold: true, sz: 14, color: { rgb: "2E75B6" } },
    alignment: { horizontal: "left" },
  };

  const dateStyle = {
    font: { sz: 11, color: { rgb: "666666" } },
    alignment: { horizontal: "left" },
  };

  const columnHeaderStyle = {
    fill: { fgColor: { rgb: "FFCCE5FF" } },
    font: { bold: true, color: { rgb: "000000" } },
    alignment: { horizontal: "left" },
  };

  if (worksheet["A1"]) worksheet["A1"].s = tripStyle;
  if (worksheet["A2"]) worksheet["A2"].s = variantStyle;
  if (worksheet["A3"]) worksheet["A3"].s = dateStyle;
  ["A5", "B5", "C5", "D5"].forEach((cell) => {
    if (worksheet[cell]) worksheet[cell].s = columnHeaderStyle;
  });

  worksheet["!cols"] = [
    { wch: 30 },
    { wch: 15 },
    { wch: 20 },
    { wch: 30 },
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Osoby uczestniczące");

  XLSX.writeFile(workbook, fileName);
};

export default exportParticipantsToExcel;
